import { Dot } from '../../../models/Dot';
import { DecisionTreeService } from '../../../services/DecisionTreeService';
import { DiagramCommentService } from '../../../services/DiagramCommentService';
import { DiagramService } from '../../../services/DiagramService';

export class FormResultGraphService {
  private readonly diagramService: DiagramService;
  private readonly diagramCommentService: DiagramCommentService

  constructor(
    private readonly decisionTreeService: DecisionTreeService,
  ) {
    this.diagramService = new DiagramService()
    this.diagramCommentService = new DiagramCommentService()
  }

  _getGraphInfo(
    graphDecisionTree : string | undefined,
    values : Record<string, any>,
    setGraphInfo
  ) {
    if (graphDecisionTree) {
      this.decisionTreeService.computeDecisionTree(graphDecisionTree, values)
        .then(
          (r) => {
            typeof r !== "string"
              ? setGraphInfo(r as any as Dot[])
              : setGraphInfo(r as string)
          }
        )
        .catch(
          (e) => {
            setGraphInfo(e.message)
          }
        )
    }
  }

  async _getDiagramInfo(
    diagramDecisionTree: string | undefined,
    values : Record<string, any>,
    setDiagramData,
    setDiagramDataIfError,

  ) {
    if (diagramDecisionTree) {
      try {
        const diagramName = await this.decisionTreeService.computeDecisionTree(diagramDecisionTree, values)
        const diagramInfo = await this.diagramService.getOneDiagramByName(diagramName as string)

        setDiagramData(diagramName as string ?? "", diagramInfo)
      }
      catch {
        setDiagramDataIfError(null)
      }
    }
  }

  _getComments(setAllComments) {
    this.diagramCommentService.getAllComments()
      .then((r) => { setAllComments(r.data) })
  }
}